module.exports = __webpack_public_path__ + "static/media/gold.d58cf4e3.svg";